module.exports = __webpack_public_path__ + "static/media/hubapprovedsob.b33625cd.xlsx";